"use strict";

exports.__esModule = true;
exports["default"] = exports.DividingLine = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _flexibleImage = _interopRequireDefault(require("../flexible-image"));

var _flexibleText = _interopRequireDefault(require("../flexible-text"));

var _excluded = ["title", "titleFont", "titleWeight", "description", "imageSrc", "dividingLine", "titleColor", "descriptionColor", "descriptionFont", "descriptionWeight", "textAlign", "children", "horizontal"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DividingLine = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "flexible-item__DividingLine",
  componentId: "sc-lq1661-0"
})(["border-bottom:3px solid ", ";"], function (props) {
  return (0, _styles.colors)("divider", props);
});
exports.DividingLine = DividingLine;
var propTypes = {
  /** Node */
  children: _propTypes.node,

  /** Node */
  description: _propTypes.node,

  /** description color oneOfType array or string  */
  descriptionColor: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),

  /** font type config oneOfType array,number or string */
  descriptionFont: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** description font weight oneOfType array, number or string */
  descriptionWeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** Boolean flag to show/hide the DividingLine */
  dividingLine: _propTypes.bool,

  /** Horizontal Flex direction, a string   */
  horizontal: _propTypes.string,

  /** image source string */
  imageSrc: _propTypes.string,

  /** Text alignment */
  textAlign: _propTypes.string,

  /** title string */
  title: _propTypes.string,

  /** title color oneOfType array or string */
  titleColor: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),

  /** font type config oneOfType array,number or string */
  titleFont: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** title font weight oneOfType array,number or string */
  titleWeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string])
};

var FlexibleItem = function FlexibleItem(_ref) {
  var title = _ref.title,
      titleFont = _ref.titleFont,
      titleWeight = _ref.titleWeight,
      description = _ref.description,
      imageSrc = _ref.imageSrc,
      dividingLine = _ref.dividingLine,
      titleColor = _ref.titleColor,
      descriptionColor = _ref.descriptionColor,
      descriptionFont = _ref.descriptionFont,
      descriptionWeight = _ref.descriptionWeight,
      textAlign = _ref.textAlign,
      children = _ref.children,
      horizontal = _ref.horizontal,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    alignItems: "center",
    as: "article",
    flexDirection: horizontal ? "row" : "column",
    mb: 4,
    px: [0, 1]
  }, props), /*#__PURE__*/_react["default"].createElement(_flexibleImage["default"], {
    alignItems: textAlign,
    flex: horizontal ? [2, 1] : "initial",
    imageSrc: imageSrc,
    mr: horizontal ? 0 : 2,
    pb: horizontal ? 3 : 0
  }), dividingLine && /*#__PURE__*/_react["default"].createElement(DividingLine, {
    mb: 3,
    mt: 2,
    width: 1
  }), /*#__PURE__*/_react["default"].createElement(_flexibleText["default"], {
    description: description,
    descriptionColor: descriptionColor,
    descriptionFont: descriptionFont,
    descriptionWeight: descriptionWeight,
    flex: horizontal ? 1 : 3,
    textAlign: textAlign,
    title: title,
    titleColor: titleColor,
    titleFont: titleFont,
    titleWeight: titleWeight
  }, children));
};

FlexibleItem.propTypes = propTypes;
FlexibleItem.displayName = "Modules.FlexibleItem";
var _default = FlexibleItem;
exports["default"] = _default;